/**
 * A shape check on the credential Google hands back, before it is worth a
 * round trip. Not verification — src/auth.py does that against Google's cert
 * chain. This only catches an obviously malformed value.
 */
export function isValidGoogleIdToken(token: unknown): boolean {
  if (typeof token !== 'string') return false;
  if (token.length < 100 || token.length > 5000) return false;

  const parts = token.split('.');
  if (parts.length !== 3) return false;
  return parts.every((part) => part.length > 0);
}
